<template>
    <div class="expands">
        <Card :bordered="false" dis-hover >
            <template #title><span class="text-primary">采购信息</span></template>
            <DescriptionList class="show-description-title" title=""  :col="4"  layout="vertical">
                <Description term="合同凭证：">
                    <a href="javascript:void(0);" @click="FileDownload(rowData.contract)">下载文件</a>
                </Description>
                <Description term="审批人：">
                    {{rowData.examine_name??'-'}}
                </Description>
                <Description term="审批时间：">
                    {{rowData.examine_time??'-'}}
                </Description>
                <Description term="备注信息：">
                    {{rowData.remark}}
                </Description>
                <Description term="收款账户：">
                    {{rowData.bank_account??'-'}}
                </Description>
                <Description term="账户实名：">
                    {{rowData.bank_real_name??'-'}}
                </Description>
                <Description term="收款银行：">
                    {{rowData.bank_name??'-'}}
                </Description>
                <Description term="开户地址：">
                    {{rowData.bank_address??'-'}}
                </Description>
            </DescriptionList>
            <div class="em-panel-box" v-if="rowData.buyer_desc">
                <Collapse accordion>
                    <Panel name="1">
                        采购描述
                        <template #content> <div class="textarea-wrap">{{rowData.buyer_desc}}</div></template>
                    </Panel>
                </Collapse>
            </div>
        </Card>

        <div class="ex-menu ex-menu-top">
            <strong class="tit text-orange">采购支出</strong>
            <ButtonGroup v-if="rowData.status === 5">
                <Button size="small" type="warning" class="text-font-sm" @click="addExpend(rowData.project_id, rowData.name, rowData.buyer_id)"><Icon type="md-add" /> 创建支出</Button>
            </ButtonGroup>
        </div>
        <Table :stripe="true" border  size="small" :columns="columns" show-summary :summary-method="handleSummary" :data="rowData.expendList" class="tables-x"  ref="selection" maxHeight="280" no-data-text="暂无数据记录">
            <template #sn="{ row }">
                <div class="d-width text-primary cursor" :title="row.sn" @click="showExpendData(row.expend_id)">
                    <span>{{row.sn}}</span>
                </div>
            </template>
            <template #pay_time="{ row }">
                <span>{{!!row.pay_time?row.pay_time:'-'}}</span>
            </template>
            <template #tax_rate="{ row }">
                <span>{{row.tax_rate}} %</span>
            </template>
            <template #project_id="{ row }">
                <div class="d-width" :title="row.project_name">
                    <span>{{row.project_name}}</span>
                </div>
            </template>
            <template #company="{ row }">
                <div class="d-width" :title="row.company">
                    <span>{{row.company}}</span>
                </div>
            </template>
            <template #pay_money="{ row }">
                <div class="d-width text-success" :title="row.pay_money">
                    <span>{{row.pay_money}}</span>
                </div>
            </template>
            <template #type_id="{ row }">
                <Tag v-if="row.type_id === 1" color="blue">{{row.type_name}}</Tag>
                <Tag v-else-if="row.type_id === 2" color="orange">{{row.type_name}}</Tag>
                <Tag v-else-if="row.type_id === 3" color="green">{{row.type_name}}</Tag>
                <Tag v-else-if="row.type_id === 4" color="purple">{{row.type_name}}</Tag>
                <span v-else>-</span>
            </template>
            <template #status="{ row }">
                <Badge v-if="row.status === 1 || row.status === 2 || row.status === 3" color="blue" :text="row.status_name" />
                <Badge v-else-if="row.status === 5" color="orange" :text="row.status_name" />
                <Badge v-else-if="row.status === 7" color="green" :text="row.status_name" />
                <Poptip v-else-if="row.status === 4 || row.status === 6" trigger="hover" width="240" :word-wrap="true" title="驳回原因：" >
                    <Badge color="red" :text="row.status_name" />
                    <template #content>
                        <p style="white-space: normal;">时间：{{row.reject_time}}</p>
                        <p style="white-space: normal;">原因：<span class="text-danger">{{row.reject_remark}}</span></p>
                    </template>
                </Poptip>
                <Badge v-else color="#999999" text="其他" />
            </template>
            <template #invoice_image="{ row }">
                <Badge v-if="row.invoice_image.length > 0" color="green" text="已上传" />
                <Badge v-else color="red" text="未上传" />
            </template>

            <template #remark="{ row }">
                <div class="d-width" :title="row.remark">
                    <span>{{row.remark}}</span>
                </div>
            </template>
            <template #action="{ row, index }">
                <a class="text-font-sm text-violet" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2) && (row.status === 1 || row.status === 2) " @click="examineExpendData(row.expend_id)">审批</a>
                <Divider type="vertical" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2) && (row.status === 1 || row.status === 2) "/>
                <a class="text-font-sm text-orange" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3) && row.status === 5 " @click="payExpendData(row.expend_id)">打款</a>
                <Divider type="vertical" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3) && row.status === 5 "/>
                <a class="text-font-sm text-primary" v-if="row.status !== 7" @click="editExpendData(row.expend_id)">编辑</a>
                <Divider type="vertical" v-if="row.status !== 7"/>
                <a class="text-font-sm text-danger" v-if="row.status !== 7" @click="deleteExpendData(row.expend_id, index)">删除</a>
                <a class="text-font-sm text-success" v-if="row.status === 7" @click="showExpendData(row.expend_id)">查看</a>
                <Divider type="vertical" v-if="row.invoice_image.length <= 0"/>
                <a class="text-font-sm text-orange" v-if="row.invoice_image.length <= 0" @click="addInvoiceData(row.expend_id)">发票</a>
            </template>
        </Table>

        <!-- 项目支出  -->
        <add-expend-modal v-if="is_expend_add" ref="AddExpendRef" @trueHandler="saveData"></add-expend-modal>

        <!-- 项目支出审批  -->
        <examine-expend-modal v-if="is_expend_examine" ref="ExamineExpendRef" @trueHandler="saveData"></examine-expend-modal>

        <!-- 项目支出财务打款  -->
        <pay-expend-modal v-if="is_expend_pay" ref="PayExpendRef" @trueHandler="saveData"></pay-expend-modal>

        <!-- 项目支出详情  -->
        <show-expend-modal v-if="is_expend_show" ref="ShowExpendRef"></show-expend-modal>

        <!-- 上传支出发票  -->
        <invoice-expend-modal v-if="is_expend_invoice" ref="InvoiceExpendRef" @trueHandler="saveData"></invoice-expend-modal>
    </div>

</template>

<script>

import AddExpendModal from "@/view/expend/Expend";
import ExamineExpendModal from "@/view/expend/Examine";
import PayExpendModal from "@/view/expend/Pay";
import ShowExpendModal from "@/view/expend/Show";
import invoiceExpendModal from "@/view/expend/Invoice";
import {deleteExpend} from "@/apis/expend";

export default {
    props: {
        rowData: {
            type: Object
        }
    },
    components: {
       AddExpendModal, ExamineExpendModal, PayExpendModal, ShowExpendModal,invoiceExpendModal

    },
    emits: ['reloadData'],
    data () {
        return {
            columns: [
                {
                    title: '编号',
                    key: 'sn',
                    slot: 'sn',
                    width : 150
                },
                {
                    title: '支出金额',
                    key: 'money'
                },
                {
                    title: '不含税金额',
                    key: 'no_tax_money',
                    width: 110
                },
                {
                    title: '费率',
                    key: 'tax_rate',
                    slot: 'tax_rate',
                    width: 90
                },
                {
                    title: '税费',
                    key: 'tax_money',
                    width: 100
                },
                {
                    title: '含税金额',
                    key: 'true_money',
                    width: 110
                },
                {
                    title: '支出类型',
                    key: 'type_id',
                    slot: 'type_id'
                },
                {
                    title: '状态',
                    key: 'status',
                    slot: 'status',
                },
                {
                    title: '发票',
                    key: 'invoice_image',
                    slot: 'invoice_image',
                },
                {
                    title: '已付金额',
                    key: 'pay_money',
                    slot: 'pay_money',
                },
                {
                    title: '付款时间',
                    key: 'pay_time',
                    slot: 'pay_time',
                },
                {
                    title: '项目',
                    key: 'project_id',
                    slot: 'project_id',
                },
                {
                    title: '供应商',
                    key: 'company',
                    slot: 'company',
                },
                {
                    title: '备注',
                    key: 'remark',
                    slot: 'remark'
                },
                {
                    title: '',
                    key: 'action',
                    slot : 'action',
                    // align: 'center',
                    // fixed : 'right',
                    width : 190
                }

            ],
            is_expend_add: false,
            is_expend_examine: false,
            is_expend_pay: false,
            is_expend_show: false,
            is_expend_invoice: false,
            site_url: this.$siteApi,
        }
    },
    created(){

    },
    methods: {
        addInvoiceData(project_id){
            let that = this;
            that.is_expend_invoice = true;
            setTimeout(function(){
                that.$refs.InvoiceExpendRef.edit(project_id);
            })
        },
        /**
         功能：
         time: 2026/1/6 11:12
         **/
        FileDownload(url){
            let that = this;
            if(url){
                //下载文件
                const fileUrl = that.site_url + url; // 文件的URL地址
                const parts = fileUrl.split('/');
                const fileName = parts[parts.length - 1];
                const link = document.createElement('a');
                link.href = fileUrl;
                link.target = '_blank';
                link.setAttribute('download', fileName);
                link.click();
            }else{
                that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
            }
        },
        /**
         功能：
         time: 2025/12/26 17:54
         **/
        addExpend(project_id, name, buyer_id){
            let that = this;
            that.is_expend_add = true;
            setTimeout(function(){
                that.$refs.AddExpendRef.adds(project_id, name, buyer_id);
            })
        },
        /**
         功能：
         time: 2025/12/27 10:22
         **/
        editExpendData(expend_id){
            let that = this;
            that.is_expend_add = true;
            setTimeout(function(){
                that.$refs.AddExpendRef.edit(expend_id);
            })
        },
        /**
         功能：
         time: 2026/1/6 15:48
         **/
        showExpendData(expend_id){
            let that = this;
            that.is_expend_show = true;
            setTimeout(function(){
                that.$refs.ShowExpendRef.show(expend_id);
            })
        },
        /**
         功能：
         time: 2025/12/27 10:33
         **/
        deleteExpendData(expend_id, index){
            let that = this;
            if(!expend_id){
                that.$Message.error({ background: true,duration:3, content:'记录不存在'});
                return;
            }
            that.$Modal.confirm({
                title: '删除记录',
                content: '此操作将删除记录不可恢复, 是否继续?',
                onOk: () => {
                    deleteExpend(expend_id).then( e =>{
                        that.rowData.expendList.splice(index , 1);
                        that.$Message.success({ background: true,duration:3, content:e.msg});
                    })
                },
                onCancel: () => {}
            });
        },
        /**
         功能：
         time: 2025/12/27 10:54
         **/
        examineExpendData(expend_id){
            let that = this;
            that.is_expend_examine = true;
            setTimeout(function(){
                that.$refs.ExamineExpendRef.show(expend_id);
            })
        },
        /**
         功能：
         time: 2025/12/27 11:35
         **/
        payExpendData(expend_id){
            let that = this;
            that.is_expend_pay = true;
            setTimeout(function(){
                that.$refs.PayExpendRef.show(expend_id);
            })
        },
        /**
         功能：
         time: 2025/12/27 13:52
         **/
        saveData(){
            this.$emit('reloadData', this.rowData.buyer_id);
        },
        /**
         功能：
         time: 2025/12/27 13:52
         **/
        handleSummary ({ columns, data }) {
            const sums = {};
            columns.forEach((column, index) => {
                const key = column.key;
                if (index === 0) {
                    sums[key] = {
                        key,
                        value: '统计'
                    };
                    return;
                }
                const values = data.map(item => Number(item[key]));
                if (!values.every(value => isNaN(value))) {
                    const v = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    if(index === 1 || index === 9){
                        sums[key] = {
                            key,
                            value: v + ' 元'
                        };
                    }else{
                        sums[key] = {
                            key,
                            value: '-'
                        };
                    }

                } else {
                    sums[key] = {
                        key,
                        value: '-'
                    };
                }
            });

            return sums;
        },

    }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.expands{
    padding: 15px 15px 20px !important;
    background: #ddd !important;
    width: calc(100vw - 242px);

    .ex-menu {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        &.ex-menu-top {
            margin-top: 20px;
        }
    }
}
</style>
